import { logger } from '../../common';

function log(info) {
  if (process.env.NODE_ENV === 'development') {
    logger(info);
  }
}

/**
 * 统计页面浏览
 * @param {string}} path 页面路径（可用于虚拟路径，如弹窗的浏览: /login_dialog）
 */
export function trackPageView(path) {
  if (!path || !_hmt) return;
  _hmt.push(['_trackPageview', path]);
  log({
    eventName: 'Pageview',
    $url: path
  });
}

/**
 * 统计事件
 * @param {string} category category：要监控的目标的类型名称，通常是同一组目标的名字，比如"视频"、"音乐"、"软件"、"游戏"等等。该项必填，不填、填"-"的事件会被抛弃。
 * @param {string} action 用户跟目标交互的行为，如"播放"、"暂停"、"下载"等等。该项必填，不填、填"-"的事件会被抛弃。
 * @param {string} option 事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项选填，不填、填"-"代表此项为空。
 */
export function trackEvent(category, action, option) {
  if (!_hmt) return;
  if (category && action) {
    const { pathname, search } = window.location || {};
    if (process.env.NODE_ENV === 'development') {
      log({
        action,
        elementName: category,
        elementValue: option,
        $url: pathname + search
      });
    } else {
      _hmt.push(['_trackEvent', category, action, option, pathname + search]);
    }
  }
}

/**
 * 统计元素点击事件
 * @param {string} elementName
 * @param {string} option
 */
export function elementClick(elementName, option) {
  trackEvent(elementName, 'click', option);
}

/**
 * 统计元素点击事件
 * @param {string} elementName
 * @param {string} option
 */
export function elementShow(elementName, option) {
  trackEvent(elementName, 'show', option);
}
